import { render } from "./AiCircleBlogDetails.vue?vue&type=template&id=18b59fe4&scoped=true"
import script from "./AiCircleBlogDetails.vue?vue&type=script&lang=js"
export * from "./AiCircleBlogDetails.vue?vue&type=script&lang=js"

import "./AiCircleBlogDetails.vue?vue&type=style&index=0&id=18b59fe4&scoped=true&lang=css"

import exportComponent from "S:\\_Projects\\TRC4\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_5cff2737dde116e8fc1156af408c1302\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b59fe4"]])

export default __exports__